// Aktav Yarka - mock data

export const COMPANY = {
  name: "Aktav Yarka",
  tagline: "Sağlıklı Yarka, Güvenilir Teslimat",
  phone: "0540 688 19 99",
  phoneRaw: "905406881999",
  email: "destek@aktavyarka.com",
  address: "Sakarya, Türkiye",
  whatsapp: "905406881999",
  yearsExp: "15+",
  satisfiedCustomers: "3.500+",
  totalCoops: "250+",
  totalChickens: "500.000+"
};

export const HERO_SLIDES = [
  {
    id: 1,
    title: "Anahtar Teslim Kümes Kurulumu",
    subtitle: "Prefabrik (Sandviç Panel) ve Çadır Kümes Kurulumlarında 15 yılı aşkın tecrübe",
    image: "https://images.pexels.com/photos/27083552/pexels-photo-27083552.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cta: "Hemen Teklif Al"
  },
  {
    id: 2,
    title: "Aşı Garantili Yarka Satışı",
    subtitle: "Ataks, Lohman Brown, Tinted Coral ve daha fazlası — veteriner kontrolünde",
    image: "https://images.pexels.com/photos/35877061/pexels-photo-35877061.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cta: "Ürünleri İncele"
  },
  {
    id: 3,
    title: "Ücretsiz Teknik Danışmanlık",
    subtitle: "Uzman ekibimizle satış öncesi ve sonrası kesintisiz destek",
    image: "https://images.pexels.com/photos/16733491/pexels-photo-16733491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cta: "Bize Ulaşın"
  }
];

export const FEATURES = [
  {
    id: 1,
    icon: "Home",
    title: "Anahtar Teslim Kümes Kurulumu",
    desc: "Prefabrik sandviç panel ve özel izolasyonlu çadır kümes kurulumları, projelendirmeden teslime kadar."
  },
  {
    id: 2,
    icon: "Egg",
    title: "Yarka & Tavuk Satışı",
    desc: "Üreticisi olduğumuz ırkları sağlıklı, aşılı ve veteriner kontrolünde sizlere sunuyoruz."
  },
  {
    id: 3,
    icon: "HeartPulse",
    title: "Ücretsiz Danışmanlık & Veterinerlik",
    desc: "Profesyonel ekibimizle satış öncesi/sonrası kesintisiz danışmanlık ve veterinerlik hizmeti."
  }
];

export const SERVICES = [
  "Yarka ve Tavuk Satışı",
  "İlçe Tarım Onaylı Kümes Kurulumları",
  "Prefabrik (Sandviç Panel) Kümes Yapıları",
  "Özel İzolasyonlu Çadır Kümesler",
  "Kümes Ekipman Satışı",
  "Canlı Hayvan Nakliyesi",
  "Teknik Destek ve Danışmanlık",
  "Veterinerlik ve Sağlık Hizmeti"
];

export const PRODUCTS = [
  {
    id: "ataks",
    name: "Ataks Tavuk",
    type: "Yumurtacı",
    image: "https://images.unsplash.com/photo-1588597989061-b60ad0eefdbf?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Türkiye koşullarına dayanıklı, yerli ve verimli bir yumurta tavuğu cinsi.",
    badge: "Çok Satan"
  },
  {
    id: "lohman-brown",
    name: "Lohman Brown Tavuk",
    type: "Yumurtacı",
    image: "https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Yüksek yumurta verimi ve dayanıklılığı ile bilinen, işletmeler için ideal bir cins."
  },
  {
    id: "tinted-coral",
    name: "Tinted Coral Tavuk",
    type: "Yumurtacı",
    image: "https://images.unsplash.com/photo-1606443589134-2c65a11ac828?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Dengeli verim ve güçlü bağışıklık özellikleriyle tercih edilir."
  },
  {
    id: "lohman-sandy",
    name: "Lohman Sandy Tavuk",
    type: "Yumurtacı",
    image: "https://images.unsplash.com/photo-1589922583749-6b8473a85048?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Lohman ailesinin verimli üyelerinden, dengeli performans sunar."
  },
  {
    id: "black-nick",
    name: "Black Nick Tavuk",
    type: "Yumurtacı",
    image: "https://images.unsplash.com/photo-1723625449830-ed7f88977635?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Güçlü dayanıklılığı ve dengeli verimiyle öne çıkan siyah tüylü cins."
  },
  {
    id: "suseks",
    name: "Suseks Tavuk",
    type: "Yumurtacı",
    image: "https://images.unsplash.com/photo-1723357018190-c0163698165b?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Dayanıklı yapısı ve dengeli yumurta verimiyle bilinen bir çeşittir."
  },
  {
    id: "sasso",
    name: "Sasso Tavuk",
    type: "Etlik & Yumurtacı",
    image: "https://images.pexels.com/photos/35282555/pexels-photo-35282555.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Et ve yumurta veriminde dengeli, bakımı kolay bir hibrit ırk.",
    badge: "Çift Verim"
  },
  {
    id: "bronz-hindi",
    name: "A.Bronz Hindi",
    type: "Hindi",
    image: "https://images.pexels.com/photos/31056807/pexels-photo-31056807.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Hızlı gelişim ve kaliteli et verimi sunan bronz hindi çeşidi."
  }
];

export const PRINCIPLES = [
  {
    icon: "Users",
    title: "Tecrübeli Uzman Ekip",
    desc: "Alanında deneyimli ekibimizle şartlarınıza ve hedeflerinize uygun cinsleri öneriyoruz."
  },
  {
    icon: "Headphones",
    title: "Satış Öncesi Danışmanlık",
    desc: "Bütçe, iklim ve pazarınıza göre en verimli cinsi birlikte belirleyip yönlendiriyoruz."
  },
  {
    icon: "LifeBuoy",
    title: "Satış Sonrası Destek",
    desc: "Besleme, aşı ve bakım süreçlerinde sürekli bilgilendirme ve destek sağlıyoruz."
  },
  {
    icon: "ShieldCheck",
    title: "Güvenilir & Kaliteli Hizmet",
    desc: "Aşılı ve seçkin hayvanları uygun araçlarla adresinize güvenle teslim ediyoruz."
  }
];

export const PROJECTS = [
  {
    id: 1,
    title: "Bursa - 5.000 Kapasiteli Prefabrik Kümes",
    location: "Bursa / İnegöl",
    image: "https://images.pexels.com/photos/16733491/pexels-photo-16733491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    year: "2024"
  },
  {
    id: 2,
    title: "Manisa - 2.000 Kapasiteli Çadır Kümes",
    location: "Manisa / Şehzadeler",
    image: "https://images.pexels.com/photos/31056807/pexels-photo-31056807.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    year: "2024"
  },
  {
    id: 3,
    title: "Çanakkale - 4.000 Kapasiteli Tavuk Kümesi",
    location: "Çanakkale / Biga",
    image: "https://images.pexels.com/photos/35282555/pexels-photo-35282555.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    year: "2023"
  },
  {
    id: 4,
    title: "Balıkesir - 3.000 Kapasiteli Sandviç Panel Kümes",
    location: "Balıkesir / Gönen",
    image: "https://images.unsplash.com/photo-1556316918-880f9e893822?crop=entropy&cs=srgb&fm=jpg&q=85",
    year: "2023"
  }
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Ahmet Yılmaz",
    city: "Bursa",
    rating: 5,
    text: "Gerçekten ürünleri çok kaliteli. Aşıları tam, sağlıklı tavuklar geldi. Tavsiye ederim."
  },
  {
    id: 2,
    name: "Emine Kara",
    city: "Manisa",
    rating: 5,
    text: "Hızlı teslimat, iletişim çok iyi. Kümes kurulumu da kusursuzdu. Tekrar sipariş vereceğim."
  },
  {
    id: 3,
    name: "Umut Demir",
    city: "Balıkesir",
    rating: 5,
    text: "Hayvanların sağlıklı ve yüksek verimli olması bizi çok sevindirdi. Ekibe teşekkürler."
  },
  {
    id: 4,
    name: "Mehmet Çelik",
    city: "Çanakkale",
    rating: 5,
    text: "Anahtar teslim kümes kurulumumuz zamanında tamamlandı. Profesyonel bir ekip."
  }
];

export const NAV_LINKS = [
  { label: "Anasayfa", href: "#home" },
  { label: "Hakkımızda", href: "#about" },
  { label: "Hizmetlerimiz", href: "#services" },
  { label: "Kümes Hayvanları", href: "#products" },
  { label: "İletişim", href: "#contact" }
];
